/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Chatgpt_AddInputs */

const en_mcp_chatgpt_add = /** @type {(inputs: Mcp_Chatgpt_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Plugins, select +, then Add custom MCP server. Paste the MCP URL and choose OAuth for authentication.`)
};

const es_mcp_chatgpt_add = /** @type {(inputs: Mcp_Chatgpt_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ve a Plugins, selecciona + y luego Add custom MCP server. Pega la URL de MCP y elige OAuth como autenticación.`)
};

/**
* | output |
* | --- |
* | "Go to Plugins, select +, then Add custom MCP server. Paste the MCP URL and choose OAuth for authentication." |
*
* @param {Mcp_Chatgpt_AddInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_chatgpt_add = /** @type {((inputs?: Mcp_Chatgpt_AddInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Chatgpt_AddInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_chatgpt_add(inputs)
	return en_mcp_chatgpt_add(inputs)
});